import classNames from 'classnames';

export const mergePropsClassName = <T>(
  props?: T,
  ...classes: (string | undefined | null)[]
): Props => ({
  ...props,
  className: classNames((props as { className?: string } | undefined)?.className, ...classes),
});
